/**
 * External URLs used throughout the application.
 * Centralized here for easy maintenance and to avoid duplication.
 */

/** Help goes to email while the in-app messenger is retired. */
export const SUPPORT_MAILTO = "mailto:support@chief.bot";
